<template>

  <modalo
    :title="approvalrule.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => approvalrule">

    <form id="approvalrule-form" v-on:submit.prevent="saveApprovalrule(approvalrule)">

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>{{ $t('Company') }}</label>
            <select-company 
              v-model="approvalrule.company_id"
              :placeholder="$t('All companies')">
              </select-company>
            <ValidateMessage :error="validateErrors.company_id" />
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <label>{{ $t('Department') }}</label>
            <select-departament 
              v-model="approvalrule.departament_id"
              :placeholder="$t('All departments')">
              </select-departament>
            <ValidateMessage :error="validateErrors.departament_id" />
          </div>
        </div>
      </div>

      <label>{{ $t('Flow') }}</label>

      <div 
        class="list-form" 
        v-sortable="{ handle: '.sortable-move', items: approvalrule.groups}">
        <div 
          class="card"
          v-for="(group, group_index) in approvalrule.groups"
          :key="group_index">

          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="mr-auto"><a href="javascript:void(0)" class="sortable-move text-secondary"><i class="fas fa-arrows-alt" /></a> {{ $t('Group') }}: {{ group_index+1 }}</div>
              <div><a href="javascript:void(0)" class="text-secondary" @click="removeGroup(group_index)"><i class="far fa-trash-alt" /></a></div>
            </div>
          </div>

          <div class="card-body">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label">{{ $t('Approvers') }}</label>
              <div class="col-sm-10">
                <approvalrule-form-approvers
                  :members="members"
                  v-model="group.approvers">
                  </approvalrule-form-approvers>
                <ValidateMessage :error="validateErrors['groups.' + group_index + '.approvers']" />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label">{{ $t('Necessary') }}</label>
              <div class="col-sm-10">
                <select class="form-control" v-model="group.approvals_required">
                  <option 
                    v-for="(approver, approver_index) in group.approvers" 
                    :key="approver_index"
                    :value="approver_index + 1">
                    {{ approver_index + 1 }} {{ ['Aprovador', 'Aprovadores'][approver_index===0?0:1] }}
                    </option>
                </select>
                <ValidateMessage :error="validateErrors['groups.' + group_index + '.approvals_required']" />
              </div>
            </div>
  
          </div>
        </div>
      </div>

      <ValidateMessage :error="validateErrors.groups" />

      <div><a href="javascript:void(0)" @click="addGroup()">{{ $t('Add group') }}</a></div>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="approvalrule-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="approvalrule._id"
          type="button"
          class="btn btn-danger"
          @click="deleteApprovalrule(approvalrule._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectCompany from '@/components/Fields/SelectCompany'
import SelectDepartament from '@/components/Fields/SelectDepartament'
import ApprovalruleFormApprovers from './ApprovalruleFormApprovers'

export default {
  name: 'ApprovalruleForm',
  components: {
    SelectCompany,
    SelectDepartament,
    ApprovalruleFormApprovers
  },
  props: [
    'initApprovalrule'
  ],
  data () {
    return {
      loading: false,
      approvalrule: this.defaulValues(this.initApprovalrule),
      validateErrors: {},
      members: []
    }
  },
  created () {
    this.loadMembers()
  },
  methods: {
    loadMembers () {
      this.$store
      .dispatch('getMembers', {sort: 'name', limit: 1000, active: true})
      .then((result) => {
        this.members = result.docs
      })
    },
    /*
    defaulValues
    */
    defaulValues (values) {
      return Object.assign({
        company_id: null,
        departament_id: null,
        groups: [{approvers: []}]
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    addGroup
    */
    addGroup () {
      this.approvalrule.groups.push({approvers: []})
    },
    removeGroup (index) {
      this.approvalrule.groups.splice(index, 1)
    },
    /*
    saveApprovalrule
    */
    saveApprovalrule (data) {
      if (data._id) this.updateApprovalrule(data)
      else this.createApprovalrule(data)
    },
    /*
    createApprovalrule
    */
    createApprovalrule (data) {
      this.loading = true

      this.$store
      .dispatch('createApprovalrule', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateApprovalrule
    */
    updateApprovalrule (data) {
      this.loading = true

      this.$store
      .dispatch('updateApprovalrule', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteApprovalrule (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteApprovalrule', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approvalrule/ApprovalruleForm.vue